import { useState, useEffect } from "react";
import { OrderStatus } from "@/redux/services/order/order.type";

const TERMINAL_STATUSES: OrderStatus[] = ["served", "picked_up", "delivered", "canceled", "rejected"];

function getElapsedText(createdAt: string): string {
  const diff = Date.now() - new Date(createdAt).getTime();
  const totalMinutes = Math.floor(diff / 60000);

  if (totalMinutes < 1) return "<1min";
  if (totalMinutes < 60) return `${totalMinutes}min`;

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${minutes}min`;
}

function getElapsedColor(createdAt: string): string {
  const diff = Date.now() - new Date(createdAt).getTime();
  const totalMinutes = diff / 60000;

  if (totalMinutes < 10) return "text-green-600";
  if (totalMinutes < 20) return "text-yellow-600";
  return "text-red-600";
}

export function useElapsedTime(
  createdAt: string,
  status: OrderStatus,
  updateInterval = 60000
) {
  const isTerminal = TERMINAL_STATUSES.includes(status);

  const [text, setText] = useState(() =>
    isTerminal ? "" : getElapsedText(createdAt)
  );
  const [colorClass, setColorClass] = useState(() =>
    isTerminal ? "" : getElapsedColor(createdAt)
  );

  useEffect(() => {
    if (isTerminal) {
      setText("");
      setColorClass("");
      return;
    }

    const update = () => {
      setText(getElapsedText(createdAt));
      setColorClass(getElapsedColor(createdAt));
    };

    update();
    const interval = setInterval(update, updateInterval);
    return () => clearInterval(interval);
  }, [createdAt, isTerminal, updateInterval]);

  return { text, colorClass, isTerminal };
}
